import React from 'react';
import Card from './common/Card';
import { Link } from 'react-router-dom';

const AuditManagement = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Audit Management</h1>
      <div className="grid grid-cols-1 gap-4">
        <Card>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h2 className="text-xl font-semibold mb-4">Corrective Action Requests</h2>
              {/* CAR Form component will go here */}
            </div>
            <div>
              <h2 className="text-xl font-semibold mb-4">Corrective Action Plans</h2>
              {/* CAP Form component will go here */}
            </div>
          </div>
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">Audit / Inspection Reports</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">External Audit Reports</h3>
              {/* External Reports component will go here */}
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Internal Audit Reports</h3>
              {/* Internal Reports component will go here */}
            </div>
          </div>
        </Card>

      
      </div>
    </div>
  );
};

export default AuditManagement;
